module.exports = __webpack_public_path__ + "img/p3@2x.e0a63ffa.png";